import { Grid } from "@mui/material";
import Accordion from "components/Accordion";
import { BtnCancelIcon, BtnPDFIcon } from "components/Button";
import React, { useCallback, useEffect, useState } from "react";

import UserRegisterForm from "./UserRegisterForm";
import { FnBlock_UI } from "components/BlockUI";
import { AxiosPost, AxiosPostFilePDF } from "utilities/Axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Decrypt, undefinedOrNull } from "utilities/Function";
import Report_PDF from "view/Report/Report_PDF";
import Report_Excel from "view/Report/Report_Excel";
import Assessment_From from "./Assessment_From";
import Consider_From from "./Consider_From";
import AdminPuloadFile from "./AdminPuloadFile";
import moment from "moment";
const RecruitmentContext = React.createContext(null);
export default function Recruitment_From() {
    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const location = useLocation();
    const searchParams = location.search;
    const nRegisterID = Decrypt(new URLSearchParams(searchParams).get('str'));
    const [objMasterData, setobjMasterData] = React.useState({} as any);

    useEffect(() => {
        onPageLoadRegisterForm(undefinedOrNull(nRegisterID, "number"));
    }, [])

    const onPageLoadRegisterForm = (nRegisterID = null) => {
        BlockUI();
        AxiosPost("UserRecruitment/onPageLoadRegisterForm", { nRegisterID: nRegisterID }, (res) => {
            setobjMasterData(res)
            console.log("res", res);

            // form.reset(res.objFormData)
        }, null, null, null, () => {
            UnBlockUI();
        })
    }

    const onGotoBackList = () => {
        if (new URLSearchParams(searchParams).get('mode') == "report") {
            navigate(`/Report`);
        }
        else if (objMasterData.isEditData === false) {
            navigate(`/Home`);
        }
        else {
            navigate(`/UserRecruitment`);
        }

    }

    //#region Export

    //#region PDF
    const [IsPDF, SetIsPDF] = useState(false);
    const onExportPDFFile = () => {
        SetIsPDF(true);
    }

    const ExportPDF = useCallback(() => {
        return (
            <>
                {IsPDF && nRegisterID &&
                    <Report_PDF
                        nID_PDF={nRegisterID}
                        IsOpen={IsPDF}
                        SetIsOpen={SetIsPDF}
                        onClickOK={(e) => {
                            console.log("e", e);
                            BlockUI();
                            let param = {
                                lstFilterExport: e,
                                nRegisterID: objMasterData?.objData?.objFormData?.nRegisterID,
                            }
                            let fileName = `Recruitment_${moment().format('yyyyMMDDHHmmss')}.pdf`;
                            AxiosPostFilePDF("UserRecruitment/ExportPDFRecrment", param, fileName, () => {
                                UnBlockUI();
                            });
                        }}
                    />}
            </>
        )
    }, [IsPDF]);
    //#endregion

    //#region Excel
    const [IsExcel, SetIsExcel] = useState(false);
    const onExportExcelFile = () => {
        SetIsExcel(true);
    }

    const ExportExcel = useCallback(() => {
        return (
            <>
                {IsExcel && nRegisterID &&
                    <Report_Excel
                        nID_Excel={nRegisterID}
                        IsOpen={IsExcel}
                        SetIsOpen={SetIsExcel}
                    />}
            </>
        )
    }, [IsExcel]);
    //#endregion

    //#endregion

    return (
        <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
            <Grid item container direction="row" xs={12} md={12} spacing={1} marginBottom={1} justifyContent="flex-end" alignItems="flex-end">
                <Grid item>
                    เลขที่ใบสมัคร : {objMasterData?.objData?.objFormData?.sRegisterCode || "-"}
                </Grid>
            </Grid>

            <RecruitmentContext.Provider value={{ objMasterData }}>
                <Grid item md={12}>
                    <Accordion header="ข้อมูลการสมัคร" isExpanded>
                        <Grid>
                            <UserRegisterForm />
                        </Grid>
                    </Accordion>
                </Grid>
                <Assessment_From />
                <Consider_From />
                <AdminPuloadFile />
                <Grid item md={12} xs={12}>
                    <Grid marginTop={4} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                        {/* <BtnExcelIcon title="เอกสาร" onClick={() => onExportExcelFile()} /> */}
                        <ExportPDF />
                        <BtnPDFIcon title="เอกสาร" style={{ marginLeft: "5px" }} onClick={() => onExportPDFFile()} />
                        {/* <ExportExcel /> */}
                        <BtnCancelIcon style={{ width: "130px" }} onClick={() => { onGotoBackList() }} />
                    </Grid>
                    {/* <Grid item>
                    <BtnExcelTable title="เอกสาร" onClick={() => onExportExcelFile()}/>
                    <ExportPDF />
                </Grid>
                <Grid item>
                    <BtnPDFTable title="เอกสาร" style={{ marginLeft: "5px" }} onClick={() => onExportPDFFile()}/> 
                    <ExportExcel />
                </Grid> */}
                </Grid>
            </RecruitmentContext.Provider>
        </Grid>
    )
}

export { RecruitmentContext };